/**
 * CSS classes to prevent translation services from modifying DOM content.
 * - `notranslate`: Recognized by Google Translate / browser built-in translators
 * - `dont_translate`: Recognized by Weglot
 */
export const NO_TRANSLATE = 'notranslate dont_translate';
